import Table from './Desktop/Table';
import List from './Mobile/List';

const Permissions = (vm) => {
  return (    
      vm.selectedRole && (
        <div className=' w-full'>
          <Table
            matriz={vm.matriz}
            isEditor={vm.isEditor}
            permissionsRoles={vm.permissionsRoles}
            permissions={vm.permissions}
            setPermissionsSave={vm.setPermissionsSave}
          />
          <List
            isEditor={vm.isEditor}
            modules={vm.matriz.modules}
            permissionsRoles={vm.permissionsRoles}
            permissionsByModule={vm.permissions}
            setPermissionsSave={vm.setPermissionsSave}
          />
        </div>   
      ) 
  );
};

export default Permissions;
